/** Status tones shared by Badge, Chip and StatusDot. Each pairing is at least 7:1. */
export type Tone = "neutral" | "info" | "ok" | "warn" | "danger" | "brand";

export const TONE_SOFT: Record<Tone, string> = {
  neutral: "border-line bg-surface-muted text-ink",
  info: "border-transparent bg-info-soft text-info",
  ok: "border-transparent bg-ok-soft text-ok",
  warn: "border-transparent bg-warn-soft text-warn",
  danger: "border-transparent bg-danger-soft text-danger",
  brand: "border-transparent bg-brand text-on-brand",
};

export const TONE_DOT: Record<Tone, string> = {
  neutral: "bg-line-strong",
  info: "bg-info",
  ok: "bg-ok",
  warn: "bg-[#b45309]",
  danger: "bg-danger",
  brand: "bg-brand",
};
